/*
 Created by CHT 2019/9/17 17:28
 金额
 */

import Digital from "./Digital"
import {
  CURRENCY_TYPE__RMB,
  CURRENCY_TYPE__DOLLAR,
  FORM_ITEM__CURRENCY, DEFAULT_VALUE__CUSTOM
} from "../types"
import {formatNum} from "../../../assets/js/Untis";

class Currency extends Digital {

  constructor() {
    super()

    this.tp = 'NO' // 开启千分符
    this.showUnit = '' // 单位
    this.currencyType = this.currencyList[0].value
    this.showUpper = 0
  }

  get title() {
    return this.fieldTitle || Currency._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }

  // 大写
  get upper() {
    let val = null
    if (this.value) {
      val = this.value
    } else if (this.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      val = this.defaultValue.customValue
    } else {
      val = this.value
    }

    return Currency.convertCurrency(val)
  }
}

Currency._title = '金额'
Currency.use = true
Currency.icon = 'iconfont icon-jine'
Currency.type = FORM_ITEM__CURRENCY
Currency.convertCurrency = function (n) {
  let fraction = ['角', '分']
  let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  let unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
  let head = n < 0 ? '欠' : ''
  n = Math.abs(n)

  let s = ''

  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

Currency.prototype.type = Currency.type
Currency.prototype.currencyList = [
  {
    value: CURRENCY_TYPE__RMB,
    label: '人民币'
  },
  {
    value: CURRENCY_TYPE__DOLLAR,
    label: '美元'
  }
]
Currency.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '大于',
    method: 'gt'
  },
  {
    name: '大于等于',
    method: 'gte'
  },
  {
    name: '小于',
    method: 'lt'
  },
  {
    name: '小于等于',
    method: 'lte'
  },
  {
    name: '选择范围',
    method: 'range'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Currency.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    currencyType: this.currencyType,
    showUpper: this.showUpper,
    checkCondition: this.checkCondition,
    defaultValue: this.defaultValue,
    showUnit: this.showUnit,
    tp: this.tp
  }
}
Currency.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.checkCondition) {
    this.checkCondition = opts.checkCondition
  }
  this.tp = opts.tp || 'NO'
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
  this.showUnit = opts.showUnit ? opts.showUnit : ''
  this.showUpper = opts.showUpper || 0
  this.currencyType = opts.currencyType || this.currencyList[0].value
}
Currency.prototype.valueToString = function (value) {
  if (Object.prototype.toString.call(value) === '[object Null]' ||
    Object.prototype.toString.call(value) === '[object Undefined]') {
    value = this.value
  }
  let type = '￥'
  if (this.currencyType === CURRENCY_TYPE__DOLLAR) {
    type = '$'
  }
  if (this.tp === 'YES') {
    value = formatNum(value)
  }
  return `${type}${value}${this.showUnit}`
}
export default Currency
